<template>
  <div class="page-container">
    <div class="page-header">
      <picture class="banner-picture">
        <source media="(max-width: 768px)" srcset="@/assets/img/banner/about_m.jpg" />
        <img class="banner-bg" src="@/assets/img/banner/about.jpg" alt="" />
      </picture>
      <div class="banner-overlay"></div>
      <div class="container">
        <h1>关于我们</h1>
        <p class="subtitle">科学 · 公正 · 准确 · 高效</p>
      </div>
    </div>
    
    <div class="container content">
      <!-- Company Profile -->
      <div class="section-block">
        <h2 class="block-title">公司简介</h2>
        <div class="profile-content">
          <div class="text-col">
            <p>紫藤检测技术有限公司（简称“紫藤检测”）成立于2021年1月18日，是一家专注于检验检测服务的专业技术机构，隶属于紫藤企管体系，坐落于郑州市高新技术产业开发区国家大学科技园，依托区域科创资源，打造集检测、技术服务于一体的综合性检测平台。</p>
            <p>公司立足科学研究与技术服务领域，以公正、精准、高效、合规为核心准则，聚焦检验检测核心业务，为各类企业、机构及个人提供覆盖多领域的检测技术解决方案。凭借规范的检测流程、专业的技术团队与完善的质量管控体系，紫藤检测严格遵循国家及行业标准，确保检测数据的科学性、准确性与权威性，助力客户把控产品质量、规避合规风险、提升市场竞争力。</p>
            <p>作为存续运营的规范化检测企业，紫藤检测始终坚守“技术立身、服务为本”的理念，持续优化检测能力、升级服务模式，致力于成为中原地区值得信赖的检验检测服务标杆，为行业高质量发展与质量强国建设贡献专业力量。</p>
          </div>
          <div class="image-col">
            <div class="image-placeholder">
              <img class="company-image" src="@/assets/img/conpany.png" alt="紫藤检测技术有限公司" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- Culture -->
      <div class="section-block culture-section">
        <h2 class="block-title">企业文化</h2>
        <div class="culture-grid">
          <div class="culture-card">
            <div class="icon">🎯</div>
            <h3>使命</h3>
            <p>用精准的数据守护人类健康与环境安全。</p>
          </div>
          <div class="culture-card">
            <div class="icon">🔭</div>
            <h3>愿景</h3>
            <p>成为国内领先、国际知名的第三方检测认证服务商。</p>
          </div>
          <div class="culture-card">
            <div class="icon">💎</div>
            <h3>价值观</h3>
            <p>诚实守信、科学严谨、客户至上、追求卓越。</p>
          </div>
        </div>
      </div>
      
      <!-- Qualifications -->
      <div class="section-block">
        <h2 class="block-title">资质荣誉</h2>
        <div class="certs-grid">
          <div class="cert-item">
            <div class="cert-placeholder">
              <img class="cert-image" src="@/assets/img/z1.png" alt="质量管理体系证书" />
            </div>
            <p>质量管理体系认证证书</p>
          </div>
          <div class="cert-item">
            <div class="cert-placeholder">
              <img class="cert-image" src="@/assets/img/z2.png" alt="CMA资质认定证书" />
            </div>
            <p>CMA资质认定证书</p>
          </div>
        </div>
      </div>
      
      <!-- Lab Environment -->
      <div class="section-block">
        <h2 class="block-title">实验室环境</h2>
        <div class="gallery-grid">
          <div class="gallery-item">
            <img class="gallery-photo" src="@/assets/img/rom1.png" alt="理化实验室" />
          </div>
          <div class="gallery-item">
            <img class="gallery-photo" src="@/assets/img/rom2.png" alt="微生物实验室" />
          </div>
          <div class="gallery-item">
            <img class="gallery-photo" src="@/assets/img/rom3.png" alt="仪器分析室" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.page-header {
  padding: 0;
  margin-bottom: 60px;
  color: #fff;
  text-align: center;
  position: relative;
  overflow: hidden;
  aspect-ratio: 4 / 1;
  display: flex;
  align-items: center;
}

.banner-picture {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: block;
}

.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: none;
}

.banner-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.08;
  background:
    radial-gradient(650px 360px at 15% 25%, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 62%),
    radial-gradient(620px 360px at 85% 45%, rgba(255, 214, 102, 0.04) 0%, rgba(255, 214, 102, 0) 64%),
    linear-gradient(135deg, rgba(125, 74, 199, 0.40) 0%, rgba(74, 20, 140, 0.34) 100%);
  z-index: 1;
}

.banner-overlay::before {
  content: '';
  position: absolute;
  inset: -25%;
  background:
    radial-gradient(closest-side at 18% 30%, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0)),
    radial-gradient(closest-side at 82% 42%, rgba(255, 189, 92, 0.18), rgba(255, 189, 92, 0)),
    radial-gradient(closest-side at 55% 90%, rgba(160, 132, 255, 0.18), rgba(160, 132, 255, 0));
  filter: blur(22px);
  opacity: 0.9;
  animation: pageBannerBlobs 18s ease-in-out infinite alternate;
}

.banner-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 10px 10px, rgba(255, 255, 255, 0.14) 2px, rgba(255, 255, 255, 0) 3px),
    radial-gradient(circle at 48px 60px, rgba(255, 255, 255, 0.10) 1px, rgba(255, 255, 255, 0) 2px);
  background-size: 70px 70px, 140px 140px;
  opacity: 0.18;
  animation: pageBannerParticles 26s linear infinite;
  pointer-events: none;
}

.page-header .container {
  display: none;
}

.page-header h1 {
  margin: 0 0 15px 0;
  font-size: 2.5rem;
  font-weight: 700;
  animation: pageFadeUp 700ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
  letter-spacing: 2px;
  animation: pageFadeUp 800ms 120ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@media (max-width: 768px) {
  .page-header {
    aspect-ratio: 4 / 5;
  }
}

@keyframes pageFadeUp {
  from { opacity: 0; transform: translate3d(0, 10px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@keyframes pageBannerZoom {
  from { transform: scale(1.06); }
  to { transform: scale(1.12); }
}

@keyframes pageBannerBlobs {
  0% { transform: translate3d(-1%, -1%, 0) scale(1); }
  50% { transform: translate3d(2%, 2%, 0) scale(1.03); }
  100% { transform: translate3d(-2%, 3%, 0) scale(1.02); }
}

@keyframes pageBannerParticles {
  from { background-position: 0 0, 0 0; }
  to { background-position: 0 -420px, 0 -840px; }
}

@media (prefers-reduced-motion: reduce) {
  .banner-bg,
  .banner-overlay::before,
  .banner-overlay::after,
  .page-header h1,
  .subtitle {
    animation: none !important;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.content {
  padding-bottom: 80px;
}

.section-block {
  margin-bottom: 80px;
}

.block-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
  padding-bottom: 15px;
}

.block-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #7D4AC7;
}

/* Profile Section */
.profile-content {
  display: flex;
  gap: 50px;
  align-items: center;
}

.text-col {
  flex: 1;
}

.text-col p {
  margin-bottom: 20px;
  line-height: 1.8;
  color: #555;
  font-size: 1.05rem;
  text-align: justify;
}

.image-col {
  flex: 1;
}

.image-placeholder {
  width: 100%;
  height: 350px;
  background-color: #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  overflow: hidden;
  opacity: 0;
  animation: contentFadeUp 700ms 140ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.company-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Culture Section */
.culture-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.culture-card {
  background: #fff;
  padding: 36px 24px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #eee;
  transition: all 0.3s;
  will-change: transform;
  opacity: 0;
  animation: contentFadeUp 700ms 160ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.culture-grid .culture-card:nth-child(2) { animation-delay: 220ms; }
.culture-grid .culture-card:nth-child(3) { animation-delay: 280ms; }
.culture-grid .culture-card:nth-child(4) { animation-delay: 340ms; }

.culture-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(125, 74, 199, 0.1);
  border-color: #e0d4f5;
}

.culture-card .icon {
  font-size: 40px;
  margin-bottom: 20px;
}

.culture-card h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.4rem;
}

.culture-card p {
  color: #666;
  line-height: 1.6;
  font-size: 14px;
  white-space: nowrap;
}

/* Certs Section */
.certs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
}

.cert-item {
  text-align: center;
  opacity: 0;
  animation: contentFadeUp 700ms 160ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.certs-grid .cert-item:nth-child(2) { animation-delay: 220ms; }
.certs-grid .cert-item:nth-child(3) { animation-delay: 280ms; }
.certs-grid .cert-item:nth-child(4) { animation-delay: 340ms; }
.certs-grid .cert-item:nth-child(5) { animation-delay: 400ms; }

.cert-placeholder {
  width: 100%;
  aspect-ratio: 3/4;
  background-color: #fff;
  border: 1px solid #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s, border-color 0.3s, background-color 0.3s;
  will-change: transform;
}

.cert-item:hover .cert-placeholder {
  transform: translateY(-6px);
  border-color: #e0d4f5;
  background-color: #faf7ff;
}

.cert-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 10px;
}

.cert-item p {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.4;
}

/* Gallery Section */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.gallery-photo {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.gallery-placeholder {
  width: 100%;
  height: 250px;
  background-color: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  border-radius: 8px;
  transition: opacity 0.3s;
  opacity: 0;
  animation: contentFadeUp 700ms 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.gallery-grid > :nth-child(2) { animation-delay: 240ms; }
.gallery-grid > :nth-child(3) { animation-delay: 300ms; }
.gallery-grid > :nth-child(4) { animation-delay: 360ms; }

.gallery-placeholder:hover {
  opacity: 0.8;
}

@keyframes contentFadeUp {
  from { opacity: 0; transform: translate3d(0, 12px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .image-placeholder,
  .culture-card,
  .cert-item,
  .gallery-placeholder {
    animation: none !important;
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .profile-content {
    flex-direction: column;
  }
  
  .image-placeholder {
    height: 250px;
  }
}
</style>
